import React from 'react';
import './Wrapper.scss';
import PropTypes from 'prop-types';

const Wrapper = ({ className, children }) => {
    return <div className={className ? 'PageWrapper ' + className : 'PageWrapper'}>{children}</div>;
};

export default Wrapper;

Wrapper.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any.isRequired
};
